export const SHIP_COUNTRIES = [
  {
    slug: 'guyana',
    name: 'Guyana',
    flag: 'https://flagcdn.com/w320/gy.png',
    emoji: '🇬🇾',
    heroImage: '/Guyana_hero_section.png',
    description:
      'Browse Japanese used vehicles currently on their way to Guyana. Every car is inspected in Japan, loaded with full shipping documentation, and tracked until it arrives.',
    gradient: 'from-emerald-600 to-green-800',
  },
  {
    slug: 'jamaica',
    name: 'Jamaica',
    flag: 'https://flagcdn.com/w320/jm.png',
    emoji: '🇯🇲',
    heroImage: '/Jamaica_hero_section.png',
    description:
      'Discover Japanese used vehicles headed for Jamaica. We handle the complete export process from auction to delivery so your car arrives ready to drive.',
    gradient: 'from-green-700 to-yellow-700',
  },
  {
    slug: 'bahamas',
    name: 'Bahamas',
    flag: 'https://flagcdn.com/w320/bs.png',
    emoji: '🇧🇸',
    heroImage: '/Bahamas_hero_section.png',
    description:
      'Quality Japanese used vehicles currently sailing to the Bahamas. Transparent pricing, full inspection reports, and reliable shipping every step of the way.',
    gradient: 'from-sky-600 to-blue-800',
  },
  {
    slug: 'cayman-islands',
    name: 'Cayman Islands',
    flag: 'https://flagcdn.com/w320/ky.png',
    emoji: '🇰🇾',
    heroImage: '/Cayman_Islands_hero_section.png',
    description:
      'Find Japanese used vehicles on their way to the Cayman Islands. Each shipment includes inspection documentation and tracking for peace of mind.',
    gradient: 'from-blue-600 to-indigo-800',
  },
  {
    slug: 'antigua',
    name: 'Antigua',
    flag: 'https://flagcdn.com/w320/ag.png',
    emoji: '🇦🇬',
    heroImage: '/Antigua_hero_section.png',
    description:
      'Japanese used vehicles currently in transit to Antigua. We deliver dependable cars with complete paperwork and dependable shipping service.',
    gradient: 'from-rose-600 to-red-800',
  },
];

export const getShipCountry = (slug) =>
  SHIP_COUNTRIES.find((c) => c.slug === (slug || '').toLowerCase());

export const getCountryName = (slug) => {
  const c = getShipCountry(slug);
  return c ? c.name : slug;
};
